// 2025-05-04: プログレスバーの状態別スタイルを head に追加する処理
export const injectHeaderLineStyles = () => {
  if (document.getElementById('storeeel-header-style')) return;

  const styleTag = document.createElement('style');
  styleTag.id = 'storeeel-header-style';
  styleTag.innerHTML = `
    .storeeel-movie-select_banner {
      height: 3px;
      background-color: rgba(255, 255, 255, 0.2);
      margin: 0 3px;
      position: relative;
      overflow: hidden;
      width: var(--banner-width, calc(100% / 1));
    }

    .storeeel-movie-select_banner::before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      height: 100%;
      background-color: white;
      width: 0%;
      /* これで常に running（再開） */
      animation-play-state: running;
    }

    .storeeel-movie-select_banner.active::before {
      animation: progressBarAnimation var(--duration, 3s) linear forwards;
    }

    .storeeel-movie-select_banner.completed::before {
      width: 100%;
      background-color: white;
      animation: none;
    }

    .storeeel-movie-select_banner.paused::before {
      animation-play-state: paused !important;
    }

    @keyframes progressBarAnimation {
      0% { width: 0%; }
      100% { width: 100%; }
    }
  `;
  document.head.appendChild(styleTag);
};

// 2025-05-04: 動画の再生時間に応じた進捗バー制御処理

// 対象インデックスのバーをアニメーション開始
export const animateCurrentProgressBar = (duration, index) => {
  const bars = document.querySelectorAll('.storeeel-movie-select_banner');
  if (!bars[index]) return;
  resetAllProgressBars(); // 全てのバーを初期状態に戻す

  for(let i = 0; i < index; i++){
    markProgressBarComplete(i); // 完了状態に変更
  }

  // リセットしてアニメーション再実行を確実にする
  bars[index].classList.remove('active');
  void bars[index].offsetWidth; // reflow 強制
  bars[index].style.setProperty('--duration', `${duration}s`);
  bars[index].classList.add('active');
};

// 対象インデックスのバーを完了状態に変更
export const markProgressBarComplete = (index) => {
  const bars = document.querySelectorAll('.storeeel-movie-select_banner');
  if (!bars[index]) return;
  bars[index].classList.remove('active');
  bars[index].classList.add('completed');
};

// 全てのバーを初期状態に戻す（グループ切り替え時など）
export const resetAllProgressBars = () => {
  document.querySelectorAll('.storeeel-movie-select_banner').forEach((bar) => {
    bar.classList.remove('active', 'completed');
    bar.style.removeProperty('--duration');
  });
};

// 進捗バーを一時停止する関数
export const pauseAllProgressBars = () => {
  document.querySelectorAll('.storeeel-movie-select_banner.active')
    .forEach(bar => bar.classList.add('paused'));
};

// 進捗バーを再開する関数
export const resumeAllProgressBars = () => {
  document.querySelectorAll('.storeeel-movie-select_banner.paused')
    .forEach(bar => bar.classList.remove('paused'));
};
